<script>
	import * as htmlToImage from "html-to-image";

	import { renderedPost, renderVis } from "./stores.js";

	const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1;

	async function handleRender() {
		window.scrollTo(0, 0);

		$renderVis = true;

		const postbox = document.querySelector("#editor");

		let ratio = (2 * 1080) / postbox.offsetWidth;

		let dataUrl = "";

		const minDataLen = Math.pow(2, 24);
		let i = 0;
		const maxTries = 5;

		if (isSafari) {
			while (dataUrl.length < minDataLen && i < maxTries) {
				dataUrl = await htmlToImage.toPng(postbox, {pixelRatio: ratio});
				i ++;
			}
		} else {
			dataUrl = await htmlToImage.toPng(postbox, {pixelRatio: ratio});	
		}

		let timestamp = Date.now();
		$renderedPost.name = `typepost-${timestamp}.png`;
		$renderedPost.url = dataUrl;
	}

	function handleCapture() {
		window.scrollTo(0, 0);

		$renderVis = true;

		let postbox = document.querySelector("#editor");
		let ratio = (2 * 1080) / postbox.offsetWidth;

		htmlToImage.toPng(postbox, {pixelRatio: ratio}).then(function (dataUrl) {
			let timestamp = Date.now();
			$renderedPost.name = `typepost-${timestamp}.png`;
			$renderedPost.url = dataUrl;
			//console.log(dataUrl);
		});
	}
</script>

<div class="panel--title">
	<h2>Render Post</h2>
</div>

<div class="panel--body">
	<button on:click={handleRender}>
		<img src="img/create.svg" alt="Render Post">
		<span>Render Post</span>
	</button>
	<button class="secondary" on:click={() => location.reload()}>
		<span>Reset</span>
	</button>
</div>

<style lang="scss">
	button {
		display: block;
		margin: 1rem 0;
		width: 100%;
	}
</style>

